import { render } from "./ModalPaymentFail.vue?vue&type=template&id=088ce4b4&scoped=true&ts=true"
import script from "./ModalPaymentFail.vue?vue&type=script&lang=ts"
export * from "./ModalPaymentFail.vue?vue&type=script&lang=ts"

import "./ModalPaymentFail.vue?vue&type=style&index=0&id=088ce4b4&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088ce4b4"]])

export default __exports__